import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from '@ndk/ng-storage';

import { AuthService } from '@core/authentication/auth.service';
import { LocalStorageKeys } from '@core/storage/local-storage.enum';

@Component({
    template: require('./page-forbidden.component.html'),
})
export class PageForbiddenComponent implements OnInit {
    constructor(
        private authService: AuthService,
        private localStorage: LocalStorageService,
    ) { }

    public ngOnInit(): void {
        this.authService.loggedIn = false;

        this.localStorage.deleteValue(LocalStorageKeys.Token);
        this.localStorage.deleteValue(LocalStorageKeys.AccountType);
    }
}
